export default __webpack_public_path__ + "static/media/new_message.56128dd4.mp3";